export const metaInfoSentiance = {
  title: 'Insights - Sentiance',
  meta: [
    {
      name: 'theme-color',
      content: '#ff3d49',
    },
    {
      name: 'description',
      description:
        'A Sentiance dashboard with segments, moments, insights and detailed information about your apps end users',
    },
  ],
  link: [
    { rel: 'shortcut icon', type: 'image/ico', href: '/static/favicon.ico' },
    { rel: 'icon', sizes: '192x192', href: '/static/icon.png' },
    { rel: 'apple-touch-icon', href: '/static/apple-touch-icon.png' },
  ],
  script: [
    {
      innerHTML: `{ version: ... }`,
      type: 'application/json',
    },
  ],
};
